export default {
  // @ts-ignore
  required: (value) => !!value || 'Dies ist ein Pflichtfeld.',
  // @ts-ignore
  email: (value) => {
    // tslint:disable-next-line:max-line-length
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(value) || 'Ungültige Email Adresse.';
  },
  // @ts-ignore
  afterToday: (value) => {
    if (!value) {
      return true;
    }
    const [day, month, year] = value.split('.');
    const dt1 = new Date();
    const dt2 = new Date(Date.UTC(year, month - 1, day, 0, 0, 0));

    return +dt1 < +dt2 || 'Datum muss in der Zukunft liegen';
  },
};
